import React, { ReactElement } from 'react';
import AppLogoBrand from './AppLogoBrand';

interface Props {
    height?: number;
    width?: number;
    useExtended?: boolean;
}

function AppLogoBrandPercona({
    height = 28,
    width = 89,
    useExtended = true,
}: Props): ReactElement {
    return (
        <AppLogoBrand
            height={height}
            logo={
                useExtended
                    ? 'vendor-mysql-brand-logo'
                    : 'vendor-mysql-brand-logo-short'
            }
            size=""
            testId="AppLogoBrandPercona"
            width={width}
        />
    );
}

export default AppLogoBrandPercona;
